import * as yup from 'yup';
import { hasValue } from '../../../../../components/inputs/inputHelpers';

export const validateInvitationEmailBody = yup.string().
  when(['invitationEmailSubject'], ([invitationEmailSubject]) => {
    if (hasValue(invitationEmailSubject)) {
      return yup.string().required('This field is required');
    }
    return yup.string().nullable();
  });

export const validateCompletionEmailBody = yup.string().
  when(['completionEmailSubject'], ([completionEmailSubject]) => {
    if (hasValue(completionEmailSubject)) {
      return yup.string().required('This field is required');
    }
    return yup.string().nullable();
  });

export const validateCaptureNationalId = yup.boolean()
  .when(['verifyNationalId', 'requireNationalId'], ([verifyNationalId, requireNationalId]) => {
    if (verifyNationalId || requireNationalId) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });


export const validateCaptureFace = yup.boolean()
  .when(['verifyFace', 'requireFace'], ([verifyFace, requireFace]) => {
    if (verifyFace || requireFace) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });


export const validateCapturePhoneNumber = yup.boolean()
  .when(['verifyPhoneNumber', 'requirePhoneNumber'], ([verifyPhoneNumber, requirePhoneNumber]) => {
    if (verifyPhoneNumber || requirePhoneNumber) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });

export const validateCaptureEmail = yup.boolean()
  .when(['verifyEmail', 'requireEmail'], ([verifyEmail, requireEmail]) => {
    if (verifyEmail || requireEmail) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });

export const validateCapturePhysicalAddress = yup.boolean()
  .when(['requirePhysicalAddress'], ([requirePhysicalAddress]) => {
    if (requirePhysicalAddress) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });

export const validateCaptureMobileMoneyNumber = yup.boolean()
  .when(['verifyMobileMoneyNumber', 'requireMobileMoneyNumber'], ([verifyMobileMoneyNumber, requireMobileMoneyNumber]) => {
    if (verifyMobileMoneyNumber || requireMobileMoneyNumber) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });


export const validateCaptureBankAccount = yup.boolean()
  .when(['requireBankAccount'], ([requireBankAccount]) => {
    if (requireBankAccount) {
      return yup.boolean().oneOf([true], 'Required').required('Required');
    }
    return yup.boolean().nullable();
  });
